<template>

  <!-- image left -->
  <div v-if="align === 'left'" class="row max-height-vertical box-overflow">

    <!-- content (mobile only to show on top.)-->
    <div class="span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card show-md" ref="contentCard">

      <div class="scroll-outer center-flex" ref="scrollHookOne">
        <div class="slide-content relative ind-1 content-translate" v-bind:class="contentActiveClass">
          <slot></slot>
        </div>
      </div>

      <span-background full="true"></span-background>
    </div>

    <!-- media -->
    <div class="span-8-lg relative ind-2 content-translate" v-bind:class="mediaActiveClass">
      <div v-if="image" class="overflow-image" ref="overflowCard" :style="ratio_styles">
        <image-component v-bind:image="image"></image-component>
      </div>
      <div v-else-if="video || videoFile" class="overflow-image" ref="overflowCard" :style="ratio_styles">
        <video-component v-bind:video="video" :videoFile="videoFile"></video-component>
      </div>
    </div>

    <!-- content (desktop/tablet only) -->
    <div class="span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card hide-md" ref="contentCard">

      <div class="scroll-outer center-flex" ref="scrollHookOne">
        <div class="slide-content relative ind-1 content-translate" v-bind:class="contentActiveClass">
          <slot></slot>
        </div>
      </div>

      <span-background full="true"></span-background>
    </div>

  </div>

  <!-- image right -->
  <div v-else class="row max-height-vertical box-overflow">

    <!-- content -->
    <div class="span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card" ref="contentCard">

      <div class="scroll-outer center-flex" ref="scrollHookOne">
        <div class="slide-content relative ind-1 content-translate" v-bind:class="contentActiveClass">
          <slot></slot>
        </div>
        <!-- originally here (span-background) -->
      </div>


      <span-background full="true"></span-background>
    </div>

    <!-- media -->
    <div class="span-8-lg relative ind-2 content-translate" v-bind:class="mediaActiveClass">
      <div v-if="image" class="overflow-image overflow-left" ref="overflowCard" :style="ratio_styles">
        <image-component v-bind:image="image"></image-component>
      </div>
      <div v-if="video || videoFile" class="overflow-image overflow-left" ref="overflowCard" :style="ratio_styles">
        <video-component v-bind:video="video" :videoFile="videoFile"></video-component>
      </div>
    </div>

  </div>

</template>

<script>
  import image_component from '../atoms/image_component'
  import video_component from '../atoms/video_component'
  import span_background from '../atoms/span_background'
  import crosshair_background from '../atoms/crosshair_background'

  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    props: ['image', 'video', 'videoFile', 'align', 'active'],
    components: {
      'image-component': image_component,
      'video-component': video_component,
      'crosshair-background': crosshair_background,
      'span-background': span_background
    },
    data() {
      return {
        ratio_styles: {
          height: ((9 / 16) * 1200) * (2 / 3) + 'px'
        },
        contentActiveClass: 'content-inactive',
        mediaActiveClass: 'content-inactive',
        psOne: null
      }
    },
    methods: {
      scrollBarInit() {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollHookOne
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      activeCallback() {
        let int = 800
        if (this.active) {
          setTimeout(() => {
            this.scrollBarInit()
            this.contentActiveClass = ''
          }, int)
          setTimeout(() => {
            if (this.psOne) this.psOne.update()
          }, int + 1000)
          setTimeout(() => {
            this.mediaActiveClass = ''
          }, int * 1.25)
        } else {
          setTimeout(() => {
            this.contentActiveClass = 'content-inactive'
          }, int)
          setTimeout(() => {
            this.mediaActiveClass = 'content-inactive'
          }, int * 1.25)
        }
      }
    },
    watch: {
      active() {
        this.activeCallback()
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '../../styles/variables'; // vertical align without flexbox
  // see http://zerosixthree.se/vertical-align-anything-with-just-3-lines-of-css/
  .overflow-image {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    padding-right: calc(100%/8);
    max-height: 100%;
    @media screen and (max-width: $md-max), screen and (max-height: $md-height-max) {
      position: relative;
      box-sizing: border-box;
      padding-right: 0px;
      padding-left: 0px;
      margin-bottom: 72px;
    }
    @media screen and (max-width: $sm-max) {
      margin-bottom: 0px;
    }
    &.overflow-left {
      padding-right: 0px;
      width: calc(100% * 1.125);
      margin-left: calc(-100%/8);
      @media screen and (max-width: $md-max), screen and (max-height: $md-height-max) {
        width: 100%;
        margin-left: 0px;
        margin-top: 72px;
      }
      @media screen and (max-width: $sm-max) {
        margin-top: 0px;
      }
    }
  }

  .slide-outer {
    display: flex;
  }

  .slide-content {
    position: relative; // margin: auto;
    padding-top: 24px;
    padding-bottom: 24px;
    max-width: calc((100% * 6/8) - 48px); // 48px to account for margin
    &.extra-max-width {
      @media screen and (max-width: $md-max), screen and (max-height: $md-height-max) {
        max-width: calc(100% - 24px - 24px);
      }
    }
  }

  .content-card {
    position: relative;
    margin: auto;
    height: 600px; // content box is span-8-lg, which is 50% of container, which maxes at 1200px.
    max-height: 100%;
    @media screen and (max-width: $md-max)/*, screen and (max-height: $md-height-max)*/
    {
      height: auto;
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// overflow_image_slide.vue?6e170f94